import { render, staticRenderFns } from "./PdfViewerComponent.vue?vue&type=template&id=7ee376a4"
import script from "./PdfViewerComponent.vue?vue&type=script&lang=ts"
export * from "./PdfViewerComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports